import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@material-ui/core';

import { useTranslations } from 'components/utilities';
import PriceSummaryListItem from './components/PriceSummaryListItem';
import { SERVICES_GROUP } from 'helpers';

const PriceSummaryList = ({ data }) => {
	const { t } = useTranslations();

	const {
		car_price_only,
		car_driver,
		car_unlimited,
		car_insurance,
		car_city_drop,
		vat_amount,
		gross_amount,
		number_of_days,
		services
	} = data;

	const filteredServices = services.filter(
		({ selected, group }) => selected && group === SERVICES_GROUP.EXTERNAL
	);

	return (
		<List>
			<PriceSummaryListItem
				title={t('car.carRentNDays', { days: number_of_days })}
				price={car_price_only}
			/>

			{car_driver && (
				<PriceSummaryListItem
					title={t('common.driver')}
					price={car_driver}
				/>
			)}

			{car_unlimited && (
				<PriceSummaryListItem
					title={t('common.unlimitedKm')}
					price={car_unlimited}
				/>
			)}

			{car_insurance && (
				<PriceSummaryListItem
					title={t('common.CDWInsurance')}
					price={car_insurance}
				/>
			)}

			{car_city_drop && (
				<PriceSummaryListItem
					title={t('car.dropOffCity')}
					price={car_city_drop}
				/>
			)}

			{filteredServices.map(({ id, label, price: { nett } }) => (
				<PriceSummaryListItem key={id} title={label} price={nett} />
			))}

			<PriceSummaryListItem title={t('car.vat')} price={vat_amount} />

			<PriceSummaryListItem
				title={t('car.totalPayment')}
				price={gross_amount}
				highlighted
			/>
		</List>
	);
};

PriceSummaryList.propTypes = {
	data: PropTypes.object
};

export default PriceSummaryList;
